import { createAsyncCategoryHandler } from "../category-dispatcher";
import { actionTools } from "./action-tools";

/**
 * Category handler for core action operations.
 * Consolidates the primary action-tools handlers for parameter management,
 * action CRUD, branching, conditions, confirmations, clipboard, and reordering.
 * Uses async dispatcher because add_to_event, add_multiple_to_event, and
 * create_conditional need reload-retry for stale action definition cache.
 */
export const handleActionCategory = createAsyncCategoryHandler(
  {
    get_parameter_options: actionTools.sync!.ui_logic_get_action_parameter_options,
    get_parameter_editor_options: actionTools.sync!.ui_logic_get_action_parameter_editor_options,
    list_parameter_binding_options: actionTools.sync!.ui_logic_list_action_parameter_binding_options,
    list_screen_actions: actionTools.sync!.ui_logic_list_screen_actions,
    list_current_actions: actionTools.sync!.ui_logic_list_current_actions,
    get_details: actionTools.sync!.ui_logic_get_action_details,
    add_to_branch: actionTools.sync!.ui_logic_add_action_to_branch,
    delete_from_event: actionTools.sync!.ui_logic_delete_action_from_event,
    delete_from_branch: actionTools.sync!.ui_logic_delete_action_from_branch,
    update_parameters: actionTools.sync!.ui_logic_update_action_parameters,
    update_properties: actionTools.sync!.ui_logic_update_action_properties,
    reorder: actionTools.sync!.ui_logic_reorder_actions,
    reorder_branch: actionTools.sync!.ui_logic_reorder_branch_actions,
    add_condition: actionTools.sync!.ui_logic_add_action_condition,
    set_condition: actionTools.sync!.ui_logic_set_action_condition,
    remove_condition: actionTools.sync!.ui_logic_remove_action_condition,
    add_confirmation: actionTools.sync!.ui_logic_add_action_confirmation,
    remove_confirmation: actionTools.sync!.ui_logic_remove_action_confirmation,
    export_clipboard: actionTools.sync!.ui_logic_export_action_clipboard,
    paste_clipboard: actionTools.sync!.ui_logic_paste_action_clipboard,
    set_managed_db_data: actionTools.sync!.ui_logic_set_action_managed_db_data,
    repopulate_target_screen_inputs: actionTools.sync!.ui_logic_repopulate_target_screen_inputs
  },
  {
    add_to_event: actionTools.async!.ui_logic_add_action_to_event,
    add_multiple_to_event: actionTools.async!.ui_logic_add_multiple_actions_to_event,
    create_conditional: actionTools.async!.ui_logic_create_conditional_action,
    // KOA-18136 — a binding to a value the running process carries may have to
    // LOAD that process first: the synchronous write can only see designer state,
    // which a headless turn leaves without any workflow parameters.
    set_parameter_binding: actionTools.async!.ui_logic_set_action_parameter_binding,
    set_multiple_parameter_bindings: actionTools.async!.ui_logic_set_multiple_parameter_bindings,
    // KOA-18136 — scoping a task feed to one process READS that process from the
    // service: designer state carries a workflow's parameters only while the BPMN
    // modeler holds it, and a build turn is nowhere near the editor.
    set_task_feed_process: actionTools.async!.ui_logic_set_task_feed_process,
    // KOA-18136 — the deterministic backstop: read the columns the screen shows
    // and make the feed carry exactly those. Async for the same reason.
    reconcile_task_feed: actionTools.async!.ui_logic_reconcile_task_feed
  }
);
